import React, { Fragment } from 'react'
import { Locale, Translation } from 'locale'
import { ClearingHouse, EntityStatus } from 'api'
import { Groupbox } from 'view/components/panels'
import { DialogField, DialogRow, TextInputField } from 'view/components/inputs'
import { ToggleField } from 'view/components/toggle'
import { RadioButtonStripField } from 'view/components/buttons'
import * as constants from 'view/styles/constants'

interface DetailsPanelProps {
  clearingHouse: ClearingHouse
  readOnly: boolean
  onUpdate: (partialClearingHouse: Partial<ClearingHouse>) => void
}

export class DetailsPanel extends React.Component<DetailsPanelProps> {
  render() {
    const { clearingHouse, readOnly, onUpdate } = this.props

    return (
      <Fragment>
        <Groupbox>
          <DialogRow verticalLayout={constants.VerticalLayout.Bottom}>
            <DialogField>
              <TextInputField
                label={Locale.translate(Translation.TC_CCP)}
                onUpdate={(publishedName: string) => {
                  onUpdate({
                    publishedName
                  })
                }}
                readOnly={readOnly}
                value={clearingHouse.publishedName}
              />
            </DialogField>
            <DialogField flex={0}>
              <RadioButtonStripField
                label={Locale.translate(Translation.TC_STATUS)}
                options={[Translation.TC_ACTIVE, Translation.TC_SUSPENDED]}
                selectedOption={clearingHouse.status === EntityStatus.ENABLED ? Translation.TC_ACTIVE : Translation.TC_SUSPENDED}
                buttonWidth={80}
                disabled={readOnly}
                onUpdate={(status: Translation) => {
                  onUpdate({
                    status: status === Translation.TC_ACTIVE ? EntityStatus.ENABLED : EntityStatus.DISABLED
                  })
                }}
              />
            </DialogField>
          </DialogRow>
        </Groupbox>
        <Groupbox>
          <DialogRow>
            <DialogField>
              <TextInputField
                label={Locale.translate(Translation.TC_CLEARING_HOUSE_MIC)}
                value={clearingHouse.marketIdentifierCode}
                readOnly={readOnly}
                onUpdate={(marketIdentifierCode: string) => {
                  onUpdate({
                    marketIdentifierCode
                  })
                }}
              />
            </DialogField>
            <DialogField>
              <TextInputField
                label={Locale.translate(Translation.TC_CLEARING_HOUSE_LEI)}
                value={clearingHouse.lei}
                readOnly={readOnly}
                onUpdate={(lei: string) => {
                  onUpdate({
                    lei
                  })
                }}
              />
            </DialogField>
            <DialogField>
              <TextInputField
                label={Locale.translate(Translation.TC_CLEARING_HOUSE_BIC)}
                value={clearingHouse.bic}
                readOnly={readOnly}
                onUpdate={(bic: string) => {
                  onUpdate({
                    bic
                  })
                }}
              />
            </DialogField>
          </DialogRow>
        </Groupbox>
        <Groupbox>
          <DialogRow>
            <DialogField>
              <ToggleField
                checked={clearingHouse.integrationReady}
                onUpdate={(integrationReady: boolean) => {
                  onUpdate({
                    integrationReady
                  })
                }}
                readOnly={readOnly}
                label={Locale.translate(Translation.TC_CLEARING_HOUSE_INTEGRATION_READY)}
              />
            </DialogField>
          </DialogRow>
        </Groupbox>
      </Fragment>
    )
  }
}
